var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroundforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "176.4px",
    height: "153.4px",
    viewBox: "0 0 176.4 153.4",
    style: {
      enableBackground: "new 0 0 176.4 153.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\r\n\t.st0{fill:#4D4D4D;}\r\n\t.st1{fill:#666666;}\r\n\t.st2{fill:#CCCCCC;}\r\n\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2.5,45.7 75.8,2.7 151.5,1.6 70.9,58.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "70.9,58.2 111.2,151.6 173.9,89.8 151.5,1.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "90.6,49.2 107.4,37.3 162.5,44.5 139.9,120 126.6,133.3 132.7,85.3 94.9,113.9 85.4,91.8 124.5,63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.9,58.2 111.2,151.6 42.9,121.3 2.5,45.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.7,76.3 85.4,91.8 94.8,113.7 27.7,93.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundforce);
export default __webpack_public_path__ + "static/media/groundforce.6ed40245a951b17ba4e2e88a744c776c.svg";
export { ForwardRef as ReactComponent };